import { Outlet, useLocation } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";
import { SidebarProvider } from "@/components/ui/sidebar";

export const AppLayout = () => {
  return (
    <SidebarProvider defaultOpen={true} className="overflow-hidden">
      <div className="flex h-screen w-full bg-background overflow-hidden">
        <AppSidebar />
        <main className="flex-1 h-full overflow-hidden flex flex-col">
          <Outlet />
        </main>
      </div>
    </SidebarProvider>
  );
};
